import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers } from 'recompose'
import { push } from 'react-router-redux'

import InstallWordpress from './component'
import * as OrgActions from 'modules/org/actions'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    updateOrgProperties: OrgActions.updateOrgProperties,
    push
  }, dispatch)
})

export default compose(
  connect(null, mapDispatchToProps),
  withHandlers({
    onContinueClick: props => () => {
      props.actions.push('/setup/touchless/install/verify')
    }
  })
)(InstallWordpress)


// WEBPACK FOOTER //
// ./src/layouts/InstallWordpress/index.js